'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AccessibleTextArea = require('./components/AccessibleTextArea.component');

var _AccessibleTextArea2 = _interopRequireDefault(_AccessibleTextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AccessibleTextArea2.default; /*
                                                 * Exports
                                                 */


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/accessibility/text-area/lib/index.js
// module id = 325
// module chunks = 0 1 4